/**
 * Single post "Share" — copies the current post URL to the clipboard.
 *
 * @return {void}
 */
export const initSocialShareCopyLink = () => {

	const button = document.querySelector( '.js-share-copy-link' );

	if ( ! button ) {

		return;

	}

	const status = document.querySelector( '.js-share-copy-status' );
	const tooltip = document.querySelector( '.js-share-copy-tooltip' );
	let hideTooltipTimeout;

	/**
	 * Announce the copy result via the aria-live status element, and show it
	 * visually as a tooltip next to the button for a few seconds.
	 *
	 * @param {string} message Message to announce.
	 * @return {void}
	 */
	const announce = ( message ) => {

		if ( status ) {

			status.textContent = message;

		}

		if ( tooltip ) {

			tooltip.textContent = message;
			tooltip.classList.add( 'is-visible' );

			clearTimeout( hideTooltipTimeout );
			hideTooltipTimeout = setTimeout( () => {

				tooltip.classList.remove( 'is-visible' );

			}, 2000 );

		}

	};

	/**
	 * Fallback copy for browsers without the async Clipboard API.
	 *
	 * @param {string} url URL to copy.
	 * @return {boolean} Whether the copy succeeded.
	 */
	const copyWithFallback = ( url ) => {

		const input = document.createElement( 'input' );
		input.value = url;
		input.setAttribute( 'readonly', '' );
		input.style.position = 'absolute';
		input.style.left = '-9999px';
		document.body.append( input );
		input.select();

		let succeeded = false;

		try {

			succeeded = document.execCommand( 'copy' );

		} catch ( error ) {

			succeeded = false;

		}

		input.remove();

		return succeeded;

	};

	button.addEventListener( 'click', async () => {

		const url = button.dataset.url || window.location.href;

		try {

			if ( navigator.clipboard && window.isSecureContext ) {

				await navigator.clipboard.writeText( url );

			} else if ( ! copyWithFallback( url ) ) {

				throw new Error( 'copy-failed' );

			}

			announce( button.dataset.copiedText || 'Link skopiowany' );

		} catch ( error ) {

			announce( button.dataset.errorText || 'Nie udało się skopiować linku' );

		}

	} );

};
